// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgPlace24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M17.6123 13.3327L17.0132 12.8815L17.0012 12.8974L16.99 12.914L17.6123 13.3327ZM12.4537 21L11.8315 21.4187L12.4537 22.3436L13.076 21.4187L12.4537 21ZM7.29428 13.3314L7.91655 12.9127L7.90545 12.8962L7.89349 12.8803L7.29428 13.3314ZM18.2114 13.7839C19.1192 12.5786 19.6576 11.078 19.6576 9.45378H18.1576C18.1576 10.7413 17.7319 11.9272 17.0132 12.8815L18.2114 13.7839ZM13.076 21.4187L18.2346 13.7513L16.99 12.914L11.8315 20.5813L13.076 21.4187ZM6.67201 13.75L11.8315 21.4187L13.076 20.5813L7.91655 12.9127L6.67201 13.75ZM5.25 9.45378C5.25 11.0773 5.78797 12.5774 6.69507 13.7824L7.89349 12.8803C7.17536 11.9263 6.75 10.7408 6.75 9.45378H5.25ZM12.4538 2.25C8.47524 2.25 5.25 5.47524 5.25 9.45378H6.75C6.75 6.30367 9.30367 3.75 12.4538 3.75V2.25ZM19.6576 9.45378C19.6576 5.47524 16.4323 2.25 12.4538 2.25V3.75C15.6039 3.75 18.1576 6.30367 18.1576 9.45378H19.6576ZM14.2854 9.45389C14.2854 10.4654 13.4654 11.2854 12.4539 11.2854V12.7854C14.2938 12.7854 15.7854 11.2938 15.7854 9.45389H14.2854ZM12.4539 7.62237C13.4654 7.62237 14.2854 8.44237 14.2854 9.45389H15.7854C15.7854 7.61394 14.2938 6.12237 12.4539 6.12237V7.62237ZM10.6224 9.45389C10.6224 8.44237 11.4424 7.62237 12.4539 7.62237V6.12237C10.6139 6.12237 9.12237 7.61394 9.12237 9.45389H10.6224ZM12.4539 11.2854C11.4424 11.2854 10.6224 10.4654 10.6224 9.45389H9.12237C9.12237 11.2938 10.6139 12.7854 12.4539 12.7854V11.2854Z" />
			</Svg>
		);
	}
);
SvgPlace24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgPlace24;
